import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, watchValues, ref ,call} from '@dbk-legacy/muster/utils';
import { addDays, addMonths, dateDiff, ymd } from '../utils/date';

require('npm-zepto');



export default () => {
  return muster()

    .path('screen.update', {
      call: async ({ req }, { get, set, call, watchValues }) => {
        console.log("window.update init");

        set('screen.online', true);

        const updateDimension = () => {
          const windowWidth = $(window).width();
          
          setTimeout(function() {
            set('screen.height', $(window).height());
            set('screen.width', windowWidth);             
          }, 100);

          set('screen.isSmall', windowWidth < 640 ? true : false);
          set('screen.isMedium', windowWidth >= 640 && windowWidth < 900 ? true : false);
          console.log("screen.update " +  $(window).height() + "x" + $(window).width());
        }
        
        updateDimension();
        



        // check for internet connection.
        const onlineCheck = () =>{
          var isOnline = navigator.onLine;
          set('screen.online', isOnline);
        }


        window.addEventListener("online", onlineCheck);
        window.addEventListener("offline", onlineCheck);

        window.addEventListener("resize", updateDimension);





        // override window alert button

        const windowAlert =(text) => {
          set('screen.alert.message', text);
          set('screen.alert.show', true);
       
        }

        (function(proxied) {
          window.alert = function(val) {
            // do something here
          
            windowAlert(val);
            
          };
        })(window.alert);


      },
    })




    .path('screen.alert.close', {
      call: async ({ req }, { get, set, call, watchValues }) => {       
         set('screen.alert.show', false);
      },
    })





    .path('screen.scrolltop', (requests, { get }) =>
      watchValues(get('ui.history.currentLocation.pathname'))
        .map(([pathname]) => {

          function scrollTo(element, to, duration) {
            if (duration <= 0) return;
            var difference = to - element.scrollTop;
            var perTick = difference / duration * 10;

            setTimeout(function() {
              element.scrollTop = element.scrollTop + perTick;
              if (element.scrollTop == to) return;
              scrollTo(element, to, duration - 10);
            }, 10);
          }

          scrollTo(document.body, 0, 600);

          return {
            path: 'screen.scrolltop',
            value: '',
          };
        })
    )





    .path('screen.alert.show', variable(false))
    .path('screen.alert.message', variable())
    .path('screen.online', variable())
    .path('screen.height', variable())
    .path('screen.width', variable())
    .path('screen.isSmall', variable())
    .path('screen.isMedium', variable());
}


